<template>
  <section id="cta" class="home3-cta">
    <v-container>
      <div class="home3-cta__card">
        <v-row align="center" justify="center">
          <v-col cols="12" md="8" class="text-center">
            <h2 class="home3-cta__title">Ready to transform your school transport?</h2>
            <p class="home3-cta__desc">
              Join schools that trust {{ systemName }} for safe, transparent, and efficient bus tracking.
            </p>

            <div class="home3-cta__actions d-flex flex-wrap justify-center">
              <template v-if="!isUserLoggedIn">
                <v-btn
                  x-large
                  rounded
                  color="primary"
                  class="px-8 mr-0 mr-sm-3 mb-3"
                  to="/register"
                >
                  {{ $t('school_signup') }}
                  <v-icon right>mdi-arrow-right</v-icon>
                </v-btn>
                <v-btn
                  x-large
                  rounded
                  outlined
                  dark
                  class="px-8 mb-3"
                  to="/login"
                >
                  {{ $t('Login') }}
                </v-btn>
              </template>
              <v-btn
                v-else
                x-large
                rounded
                color="primary"
                class="px-8"
                :to="dashboardRoute"
              >
                {{ $t('dashboard') }}
                <v-icon right>mdi-view-dashboard-outline</v-icon>
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </div>
    </v-container>
  </section>
</template>

<script>
export default {
  props: {
    systemName: {
      type: String,
      required: true,
    },
    isUserLoggedIn: {
      type: Boolean,
      default: false,
    },
    userRole: {
      type: String,
      default: null,
    },
  },
  computed: {
    dashboardRoute() {
      return this.userRole === 'admin' ? '/admin-dashboard' : '/school-dashboard'
    },
  },
}
</script>

<style lang="scss" scoped>
@import './home3-theme.scss';

.home3-cta {
  @include home3-section-padding;
  background: #fff;
}

.home3-cta__card {
  padding: 4rem 2rem;
  border-radius: $home3-radius;
  background: $home3-gradient;
  box-shadow: $home3-shadow-lg;
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    inset: 0;
    background: radial-gradient(circle at 80% 20%, rgba(255, 255, 255, 0.08) 0%, transparent 50%);
    pointer-events: none;
  }
}

.home3-cta__title {
  font-size: clamp(1.5rem, 3vw, 2rem);
  font-weight: 700;
  color: #fff;
  letter-spacing: -0.02em;
  margin-bottom: 1rem;
  position: relative;
}

.home3-cta__desc {
  font-size: 1.05rem;
  line-height: 1.7;
  color: rgba(255, 255, 255, 0.82);
  max-width: 520px;
  margin: 0 auto 2rem;
  position: relative;
}

.home3-cta__actions {
  position: relative;
}
</style>
